export default __webpack_public_path__ + "static/media/cj_koh.235189b1.png";